/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Action } from '../../../../components/ActionsCard/ActionCard';
import { strings } from '../../../../intl/Strings';
import { logger } from '../../../../shared';
import { TrialActionId } from '../shared';

export const PowerpointTryCopilotActionCard = (showSecondary: boolean = true): Action => ({
    id: TrialActionId.TryCopilotDialog,
    checked: false,
    primaryContent: strings.getString('trialconversionPowerpointTryCopilotDialogHeader'),
    secondaryContent: strings.getString('trialconversionPowerpointTryCopilotDialogContent'),
    showSecondaryContent: showSecondary,
    onClick: () => logger.logInfo('TrialConversionPowerpointCard', 'Try Copilot clicked'),
    retriggerable: true
});
